module.exports = __webpack_public_path__ + "static/img/8.48e5286.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/sp/8.png
// module id = Yqxz
// module chunks = 0